import { CurrencyAmount } from '@etcswapv2/sdk-legacy'
import { MIN_ETH } from '../constants'

/**
 * Given some token amount, return the max that can be spent of it
 * @param currencyAmount to return max of
 */
export function maxAmountSpend(currencyAmount?: CurrencyAmount): CurrencyAmount | undefined {
  if (!currencyAmount) return undefined
  // Use 'address' property check instead of reference equality to avoid module duplication issues
  const isNativeCurrency = currencyAmount.currency && !('address' in currencyAmount.currency)
  if (isNativeCurrency) {
    if (currencyAmount.raw > MIN_ETH) {
      return CurrencyAmount.ether(currencyAmount.raw - MIN_ETH)
    } else {
      return CurrencyAmount.ether(0n)
    }
  }
  return currencyAmount
}
